import { FederatedMouseEvent } from "./mouse-event";

export class FederatedWheelEvent extends FederatedMouseEvent {
    constructor() {
        super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
    }
    clone() {
        var _a, _b, _c;
        const event = new FederatedWheelEvent(this.manager);
        event.eventPhase = event.NONE, event.currentTarget = null, event.path = [], event.detailPath = [], 
        event.target = null, event.nativeEvent = this.nativeEvent, event.originalEvent = this.originalEvent, 
        null === (_a = this.manager) || void 0 === _a || _a.copyWheelData(this, event), 
        null === (_b = this.manager) || void 0 === _b || _b.copyMouseData(this, event), 
        null === (_c = this.manager) || void 0 === _c || _c.copyData(this, event), event.target = this.target, 
        event.path = this.composedPath().slice();
        const p = this.composedDetailPath();
        return event.detailPath = p && p.slice(), event.type = this.type, event;
    }
}

FederatedWheelEvent.DOM_DELTA_PIXEL = 0, FederatedWheelEvent.DOM_DELTA_LINE = 1, 
FederatedWheelEvent.DOM_DELTA_PAGE = 2;
//# sourceMappingURL=wheel-event.js.map
